import { useEffect } from "react";
import { useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import {
  fetchActivitiesReservations,
  fetchActivityReservationDetails,
  fetchAddonReservationDetails,
  fetchAddonsReservations,
  fetchCarRentalReservationDetails,
  fetchCarRentalReservations,
  fetchFerryReservationDetails,
  fetchFerryReservations,
  fetchFlightReservationDetails,
  fetchFlightsReservations,
  fetchHotelReservationDetails,
  fetchHotelReservations,
  fetchTrainReservationDetails,
  fetchTrainReservations,
  fetchTransferReservationDetails,
  fetchTransfersReservations,
} from "../../../api/reservations";
import _ from "lodash";
import { custom_auth } from "../../../context";
import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";

export const useProductReservations = (productType, showDetailsModal) => {
  const { user } = useAuth0();
  var external_creator = user?.sub;
  const ext_user_id = useSelector(
    (state) => state?.GuestProfile?.extProfile?.ext_user_id
  );
  if (custom_auth) external_creator = ext_user_id;

  var fetchFn = null;
  switch (productType) {
    case "ACC":
      fetchFn = fetchHotelReservations;
      break;
    case "FL":
      fetchFn = fetchFlightsReservations;
      break;
    case "TRF":
      fetchFn = fetchTransfersReservations;
      break;
    case "ACT":
      fetchFn = fetchActivitiesReservations;
      break;
    case "MI":
      fetchFn = fetchAddonsReservations;
      break;
    case "FER":
      fetchFn = fetchFerryReservations;
      break;
    case "TRA":
      fetchFn = fetchTrainReservations;
      break;
    case "CAR":
      fetchFn = fetchCarRentalReservations;
      break;
    default:
      break;
  }

  const { data, isLoading } = useQuery({
    queryKey: ["reservations", productType, external_creator],
    queryFn: () => fetchFn({ external_creator }),
    refetchOnWindowFocus: false,
    enabled: !!external_creator && !showDetailsModal,
  });

  const reservations = data?.data?.results ?? [];
  const loading = isLoading;

  return { reservations, loading };
};

export const useProductDetailsReservations = (
  productType,
  reservationRefId
) => {
  var fetcherFn = null;
  switch (productType) {
    case "ACC":
      fetcherFn = fetchHotelReservationDetails;
      break;
    case "FL":
      fetcherFn = fetchFlightReservationDetails;
      break;
    case "TRF":
      fetcherFn = fetchTransferReservationDetails;
      break;
    case "ACT":
      fetcherFn = fetchActivityReservationDetails;
      break;
    case "MI":
      fetcherFn = fetchAddonReservationDetails;
      break;
    case "FER":
      fetcherFn = fetchFerryReservationDetails;
      break;
    case "TRA":
      fetcherFn = fetchTrainReservationDetails;
      break;
    case "CAR":
      fetcherFn = fetchCarRentalReservationDetails;
      break;
    default:
      break;
  }

  const { data, isLoading } = useQuery({
    queryKey: ["reservation", reservationRefId, productType],
    queryFn: () => fetcherFn({ reservationRefId }),
  });
  const reservation = data?.data;
  const loading = isLoading;
  return { reservation, loading };
};
